<template>
  <v-container class="pa-0">
    <v-tooltip :disabled="flag === null"
               bottom>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs"
             v-on="on">
          <v-badge :value="flag !== null"
                   :color="flag === 0 ? 'quaternary' : flag > 1 ? '#FF8073' : '#FFD262'"
                   offset-y="9"
                   offset-x="4"
                   dot>
            <slot>
              <!-- icon -->
            </slot>
          </v-badge>
        </div>
      </template>
      <span>{{flag === 0 ? $t("servicesystem.common_objects.machine.ok") : (flag > 1 ? $t("servicesystem.common_objects.machine.problem") : $t("servicesystem.common_objects.machine.notice"))}}</span>
    </v-tooltip>
  </v-container>
</template>


<script>
export default {
  name: "FlagIconWrapper",
  props: {
    flag: Number,
  },
  components: {},

  data: () => ({
    disabled: false,
  }),

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>